// Зеркало бековской ru.avtoapp.nomenclature.constants.ComplexPriceVendorCodes
// (admin.api): комплексы шиномонтажа, у которых цена берётся напрямую из
// price_list_item по vendor-коду позиции (механика с 22.09.2026, без суммирования
// состава бандла). Ключ — complexRefValueId (ref-значение справочника комплексов,
// тот же id, что в TYPE_OPERATION и в ответах /complexes, /complex_prices).
// Если бек дополнит карту — синхронизировать вручную.
export const COMPLEX_PRICE_VENDOR_CODES: Readonly<Record<number, string>> = {
  361: 'complexTireFitting', // TYPE_OPERATION.TIRE_SERVICE_COMPLEX_1_361
  244: 'complexWheelReplacement', // TYPE_OPERATION.TIRE_SERVICE_COMPLEX_2_244
  487: 'complexLowProfile', // TYPE_OPERATION.TIRE_SERVICE_COMPLEX_3_487
  741: 'complexReinforcedCord', // TYPE_OPERATION.TIRE_SERVICE_COMPLEX_4_REINFORCED_CORD_741
  742: 'complexOffRoad', // TYPE_OPERATION.TIRE_SERVICE_COMPLEX_5_OFF_ROAD_742
};

// Обратная проверка «эта позиция прайса — прямая цена комплекса»
export const COMPLEX_VENDOR_CODE_SET: ReadonlySet<string> = new Set(Object.values(COMPLEX_PRICE_VENDOR_CODES));

// vendorCode позиции → complexRefValueId: какой комплекс формирует эта позиция
// (hover-подсветка строки комплекса при наведении на позицию в «Розничных ценах»)
export const COMPLEX_REF_VALUE_ID_BY_VENDOR_CODE: ReadonlyMap<string, number> = new Map(
  Object.entries(COMPLEX_PRICE_VENDOR_CODES).map(([id, vendorCode]) => [vendorCode, Number(id)])
);
